import { ContentItem } from '@apptus/esales-api';
import { IQuickSearchResultArticle } from '../../../../types';
import handleFromUrl from '../../../../../../util/handleFromUrl';
import { generateContentTicket } from '../handleTickets';

const mapArticle = (articleInResp: ContentItem, searchTerm?: string): IQuickSearchResultArticle => {
  // Store the ticket in localStorage if we have a search term (autocomplete context)
  if (searchTerm && articleInResp.ticket) {
    generateContentTicket(articleInResp, searchTerm);
  }

  return {
    id: articleInResp.key.toString(),
    handle: handleFromUrl(articleInResp.link),
    title: articleInResp.title,
    url: articleInResp.link,
    ticket: articleInResp.ticket,
    description: articleInResp.description,
    image: articleInResp.image?.sources?.[0]?.url
  };
};

export default mapArticle;
